import { makeVar } from "@apollo/client";
import { useReactiveVar } from "@apollo/client/react";

import { createTelemetryEvent } from "../telemetry/Telemetry";
import { telemetryChannelName } from "../util/constants";
import { useAppState } from "./useAppState";
import { useRouteChangeEffect } from "./useRouteChangeEffect";
export const featureName = "progressView";
export const openActionType = "open";

const progressModalOpen = makeVar(false);
const progressModalParams = makeVar<{
  courseId?: number;
  courseUuid?: string;
  instanceId?: string;
  fromLibrary?: boolean;
}>({});

export function useProgressModal() {
  const { appState } = useAppState();
  const modalOpen = useReactiveVar(progressModalOpen);
  const setModalOpen = (open: boolean) => {
    progressModalOpen(open);

    // Calculate progress percentage from instance data
    let progressInfo = "unknown";
    if (appState.instance?.progress) {
      const { viewedSlides, totalSlides } = appState.instance.progress;
      if (viewedSlides !== undefined && totalSlides !== undefined && totalSlides > 0) {
        const percentComplete = Math.ceil((viewedSlides / totalSlides) * 100);
        progressInfo = `${percentComplete}% slides completed`;
      }
    }

    createTelemetryEvent({
      feature: "progress view",
      action: openActionType,
      action_meta: progressInfo,
    }).fire(telemetryChannelName);
  };

  const modalParams = useReactiveVar(progressModalParams);

  const openModal = (params: typeof modalParams) => {
    progressModalParams(params);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  useRouteChangeEffect(() => {
    if (modalOpen) {
      closeModal();
    }
  });

  return {
    modalOpen,
    modalParams,
    openModal,
    closeModal,
  };
}
